import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  Spinner,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//i18n
import { withTranslation } from "react-i18next";

// actions
import { logoutUser } from "../../../store/auth/login/actions";

import ProfilePicture from "../../Common/ProfilePicture";

const ProfileMenu = ({ t, onclick }) => {
  const [menu, setMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const { data, loadingLogout, error } = useSelector((state) => state.Login);

  const toggleModal = () => {
    setModal(!modal);
    removeBodyCss();
  };
  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const toggle = () => {
    setMenu(!menu);
  };

  //Dispatiching states
  const dispatch = useDispatch();
  const history = useHistory();

  // handleValidSubmit
  const handleLogout = () => {
    dispatch(logoutUser(history));
  };

  let showToast = function (type, msg) {
    toastr[type](msg);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  useEffect(() => {
    if (error) {
      showToast("error", t("Logout Error"));
    }
  }, [error, t]);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center">
            {data && data.user && (
              <ProfilePicture
                name={data.user.name}
                src={data.user.url_avatar}
                sizePx={40}
              />
            )}
            <span className="d-none d-xl-inline-block ml-2 mr-1">
              {data && data.user && data.user.name}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </div>
        </DropdownToggle>
        <DropdownMenu right>
        <Link to={`/edit-profile`}>
          <DropdownItem href="#">
            <i className="bx bx-user font-size-16 align-middle mr-1"></i>
            {t("Profile")}
          </DropdownItem>
          </Link>
          <DropdownItem tag="a" href="#" onClick={onclick}>
            <i className="bx bx-wrench font-size-16 align-middle mr-1"></i>
            {t("Settings")}
          </DropdownItem>
          <div className="dropdown-divider"></div>
          <DropdownItem onClick={toggleModal}>
            <Link to="#" className="dropdown-item" style={{ padding: "0" }}>
              <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
              <span>{t("Logout")}</span>
            </Link>
          </DropdownItem>
          </DropdownMenu>
      </Dropdown>
          <Modal isOpen={modal}>
            <div className="modal-body">
              <h5 style={{ textAlign: "center", fontSize: "30px" }}>
                {t("Do you want to leave the platform ?")}
              </h5>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={toggleModal}
                className="btn btn-danger waves-effect"
                data-dismiss="modal"
                style={{ backgroundColor: "#f14646" }}
              >
                {t("No")}
              </button>

              {loadingLogout ? (
                <button
                  type="button"
                  className="btn btn-secondary waves-effect waves-light"
                  disabled={true}
                  style={{
                    cursor: "no-drop",
                  }}
                >
                  <Spinner
                    size="sm"
                    animation="border"
                    style={{
                      height: "18px",
                      width: "18px",
                    }}
                  />
                </button>
              ) : (
                <button
                  onClick={handleLogout}
                  type="button"
                  className="btn btn-secondary waves-effect waves-light"
                >
                  <Link to="#" style={{ color: "black" }}>
                    {t("Yes")}
                  </Link>
                </button>
              )}
            </div>
          </Modal>        
    </React.Fragment>
  );
};

export default withTranslation()(ProfileMenu);
